/*
 *
 * PatientSchedule reducer
 *
 */
import { fromJS } from 'immutable';

import {
	FETCH_PROFILE,
	FETCH_PROFILE_FAILURE,
	FETCH_PROFILE_SUCCESS,
	FETCH_SESSIONS,
	FETCH_SESSIONS_FAILURE,
	FETCH_SESSIONS_SUCCESS,
} from './constants';

export const initialState = fromJS({
	events: [],
	loading: false,
	error: null,
	profileError: null,
	subscribeUrls: {
		standard: null,
		privatized: null,
	},
});

function patientScheduleReducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_SESSIONS:
			return state.merge({
				loading: true,
				error: null,
			});
		case FETCH_SESSIONS_SUCCESS:
			return state.merge({
				events: action.events || [],
				loading: false,
				error: null,
			});
		case FETCH_SESSIONS_FAILURE:
			return state.merge({
				loading: false,
				error: action.error,
			});

		case FETCH_PROFILE:
			return state;
		case FETCH_PROFILE_SUCCESS: {
			const profile = action.profile || {};
			return state
				.set(
					'subscribeUrls',
					fromJS({
						standard: profile.calendarFeedUrl || null,
						privatized: profile.calendarFeedUrlPrivatized || null,
					}),
				)
				.set('profileError', null);
		}
		case FETCH_PROFILE_FAILURE:
			return state.set('profileError', action.error);

		default:
			return state;
	}
}

export default patientScheduleReducer;
